document.addEventListener("DOMContentLoaded", function () {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const elementsToReveal = document.querySelectorAll('.product-card-enhanced, .bento-grid__item, .section-header, .feature-row__item');
    elementsToReveal.forEach(el => {
        el.classList.add('reveal-on-scroll');
        observer.observe(el);
    });
});
